import React, { Fragment } from 'react'
import { object } from 'prop-types'
import fetch from 'isomorphic-fetch'
import { connect } from 'react-redux'
import styles from './AccountVerificationPage.styl'

class AccountVerificationPage extends React.Component {

	static displayName = 'AccountVerificationPage'

	static propTypes = {
		match: object,
		session: object
	}

	constructor(props) {
		super(props)
		const { match: { params: { token } } } = props
		this.state = {
			token,
			processing: !!token,
			validationSuccess: false,
			newCodeSuccess: false,
			activationError: false
		}
	}

	componentDidMount() {
		const { session } = this.props
		const { token } = this.state
		if (session.isActive) {
			window.location = '/apt/plans'
			return
		}
		if (token && Object.keys(session).length) {
			this.handleActivation(token, '/apt/plans')
		}
	}

	handleActivation(token, redirect) {
		fetch(`/api/accounts/verify_user/${ token }`, { credentials: 'include' })
			.then(r => r.json())
			.then(r => {
				if (r.statusCode === 400) {
					this.setState({ activationError: true, processing: false })
				} else if (r.success) {
					this.setState({ processing: false, validationSuccess: true }, () => {
						setInterval(() => { window.location = redirect }, 1600)
					})
				}
			})
			.catch(e => console.log(e))
	}

	handleNewCode() {
		fetch('/api/accounts/send_verification_token', { credentials: 'include' })
			.then(r => r.json())
			.then(() => {
				this.setState({ newCodeSuccess: true, activationError: false })
			})
			.catch(e => console.log(e))
	}

	renderActivationErrorMessage(hasSession) {
		const link = (
			<span
				onClick={ hasSession ? this.handleNewCode.bind(this) : () => { this.setState({ activationError: false }) } }
				className={ styles['link-emphasis'] }
			>aqui</span>
		)
		return <h4>O link de ativação utilizado não é válido, clique <b>{ link }</b> para enviar um novo link de ativação!</h4>
	}

	renderProcessingMessage() {
		return <div><h4>A processar ativação ...</h4></div>
	}

	renderNewTokenSuccessMessage() {
		return <h4>Email enviado com sucesso!</h4>
	}

	renderEmailVerificationSuccessMessage() {
		return <h4>Conta ativada com sucesso! Irá ser redirecionado dentro de poucos segundos.</h4>
	}

	renderNewTokenMessage(session) {
		const link = (
			<span
				onClick={ this.handleNewCode.bind(this) }
				className={ styles['link-emphasis'] }
			>aqui</span>
		)
		return (
			<Fragment>
				<h2>Caro { session.name },</h2>
				<p>A verificação do seu e-mail está em falta.</p>
				<p>Verifique se recebeu um email com informação sobre como ativar o email.</p>
				<p>Caso não tenha recebido, clique <b>{ link }</b> para reenviar o link para ativação!</p>
			</Fragment>
		)
	}

	renderNoSessionMessage(token) {
		const link = (
			<span
				onClick={ () => {
					if (window) {
						window.location = `/login?redirect=/account_verification${ token ? `/${ token }` : '' }`
					}
				} }
				className={ styles['link-emphasis'] }
			>aqui</span>
		)
		return (
			<Fragment>
				<h2>Caro atleta,</h2>
				<p>A verificação do seu e-mail está em falta.</p>
				<h4>É necessário fazer login <b>{ link }</b> antes de conseguir reenviar o link para ativação!</h4>
			</Fragment>
		)
	}

	render() {
		const { session } = this.props
		const { newCodeSuccess, validationSuccess, processing, activationError, token } = this.state
		const hasSession = Object.keys(session).length
		return (
			<div className={ styles['activation'] }>
				<div className={ styles['content'] }>
					<div className={ styles['details'] }>
						{
							activationError && this.renderActivationErrorMessage() ||
							!hasSession && this.renderNoSessionMessage(token) ||
							processing && this.renderProcessingMessage() ||
							validationSuccess && this.renderEmailVerificationSuccessMessage() ||
							newCodeSuccess && this.renderNewTokenSuccessMessage() ||
							this.renderNewTokenMessage(session)
						}
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = state => ({
	session: state.session
})

export default connect(mapStateToProps)(AccountVerificationPage)



// WEBPACK FOOTER //
// ./src/client/website/pages/AccountVerificationPage/AccountVerificationPage.js